import axios from "axios";
import {
  KmlInfoFkKmlInfoList,
  ShpInfoFkSmlInfoList,
  sysDictTypeDropDown,
  editKmlInfo,
  editShpInfo,
} from "@/api/api";
import * as kmlMap from "@/components/tables/program/map.js";
import * as shpInfoListMap from "@/components/tables/shpInfoList/map.js";
const MapModal = () => import("@/components/common/mapModal/Index");

export default {
  name: "bimVectorAddKml",
  props: ["isSecondaryAdd"],
  components: { MapModal },
  data() {
    return {
      bimVectorAddKml: {
        title: "导入数据",
        id: "bimVectorAddKml", // id和ref使用的同一个
      },
      modalNode: {
        bimVectorAddKml: {
          show: true, // 默认展示
          loading: false, // 加载loading
          // offset: {
          //   // 默认弹出层偏移
          //   x: 55,
          //   y: -740,
          //   // unit: "px", // 默认px
          // },
          // width: "30%", // 宽度配置 默认450px
          height: "85%", // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: true,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
        },
      },
      predefineColors: [
        //颜色选择器
        "#ffffff",
        "#c71585",
        "#ff4500",
        "#ffd700",
        "#55e8a2",
        "#1ba784",
        "#00ced1",
        "#1e90ff",
        "#9932cd",
        "#000000",
      ],
      OptimizationDegreeOptions: [
        {
          name: "低",
          value: "low",
        },
        {
          name: "中",
          value: "medium",
        },
        {
          name: "高",
          value: "high",
        },
      ],
      fontStyleOptions: ["微软雅黑", "宋体", "楷体", "隶书", "黑体"],
      lineMaterialOptions: [],
      lineMaterialKmlOptions: [
        { code: "Color", value: "实体" },
        { code: "Water", value: "水域" },
      ],
      form: {
        selectGrouping: null,
        fileName: null,
        actionUrl: "/baseIP/KmlInfo/upload",
        clampToGround: true,
        diffHeight: 0,
        visibleRange: 12000,
        fontStyle: "黑体",
        textSize: 12,
        textColor: "#FF0000",
        outLine: true,
        sideColor: "#ffffff",
        scaleByDistance: false,
        isAreaSideColor: true,
        areaSideColor: "#ffffff",
        fill: true,
        areaColor: "#FFFF00",
        transparency: 0.5,
        shpColor: "#ffffff",
        gapColor: "",
        width: 5,
        materialType: "Color",
        dashLength: 16,
        backGround: false,
        backGroundColor: "#ffffff",
        isOptimization: false,
        optimizationDegree: "low",
      },
      selectGroupingList: [],
      isKmlOrShpWithUpload: 1,
      fileList: [],
      uploadAccept: ".kml",
    };
  },
  methods: {
    // 关闭自己清空数据
    closeVector() {
      this.resetData();
      this.$emit("closeNewGrouping");
    },
    // 清除数据
    resetData() {
      this.form = {
        selectGrouping: null,
        fileName: null,
        actionUrl: "/baseIP/KmlInfo/upload",
        clampToGround: true,
        diffHeight: 0,
        visibleRange: 12000,
        fontStyle: "黑体",
        textSize: 12,
        textColor: "#FF0000",
        outLine: true,
        sideColor: "#ffffff",
        scaleByDistance: false,
        isAreaSideColor: true,
        areaSideColor: "#ffffff",
        fill: true,
        areaColor: "#FFFF00",
        transparency: 0.5,
        shpColor: "#ffffff",
        gapColor: "",
        width: 5,
        materialType: "Color",
        dashLength: 16,
        backGround: false,
        backGroundColor: "#ffffff",
        isOptimization: false,
        optimizationDegree: "low",
      };
      this.fileList = [];
      this.uploadAccept = ".kml";
      this.isKmlOrShpWithUpload = 1;
      this.form.selectGrouping = this.selectGroupingList[0]
        ? this.selectGroupingList[0]
        : null;
    },
    submitInfo() {
      if (this.fileList.length === 0 && !this.isSecondaryAdd.editKmlShpData) {
        this.$notify({
          title: "请上传文件",
          message: "",
          type: "error",
          duration: 960,
          offset: 320,
        });
        return;
      }
      // 新增
      if (!this.isSecondaryAdd.editKmlShpData) {
        const formData = new FormData();
        formData.append("files", this.fileList[0].raw); //上传的文件
        formData.append("projectId", sessionStorage.getItem("nowProjectId")); //项目ID
        formData.append("activation", true); //默认显示/激活
        formData.append("pId", this.form.selectGrouping.id); //分组ID
        formData.append("isOptimization", this.form.isOptimization); //是否优化
        formData.append("optimizationDegree", this.form.optimizationDegree); //优化等级
        formData.append("fontStyle", this.form.fontStyle); //字体
        formData.append("textSize", this.form.textSize); //字体大小
        formData.append("textColor", this.form.textColor); //字体颜色
        formData.append("sideColor", this.form.sideColor); //字体描边颜色
        formData.append("areaColor", this.form.areaColor); //填充颜色
        formData.append("isAreaSideColor", this.form.isAreaSideColor); //边线颜色
        formData.append("areaSideColor", this.form.areaSideColor); //边线颜色
        formData.append("textDistinct", this.form.visibleRange); //可见范围
        formData.append("diffHeight", this.form.diffHeight); //高度
        formData.append("clampToGround", this.form.clampToGround); //贴地
        formData.append("materialType", this.form.materialType); //材质
        formData.append("transparency", this.form.transparency); //透明度
        formData.append("outLine", this.form.outLine); //描边
        formData.append("fill", this.form.fill); //填充
        formData.append("backGround", this.form.backGround); //背景
        formData.append("backGroundColor", this.form.backGroundColor); //背景颜色
        // KML提交
        if (this.isKmlOrShpWithUpload == 1) {
          formData.append("kmlName", this.form.fileName);
          axios
            .post("/baseIP/KmlInfo/upload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization:
                  "Bearer " + window.sessionStorage.getItem("token"),
                "X-Authorization":
                  "Bearer " + window.sessionStorage.getItem("refreshToken"),
              },
            })
            .then((res) => {
              if (res.data.code == 200 || res.data.code == 204) {
                kmlMap.removeLayer();
                this.closeVector();
                this.$emit("addKmlOrShpSuccess");
                this.$notify({
                  title: "保存成功",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              }
            });
        }
        // SHP提交
        if (this.isKmlOrShpWithUpload == 2) {
          // 可见范围，线色，线宽，材质
          formData.append("ShpDistinct", this.form.visibleRange);
          formData.append("shpColor", this.form.shpColor);
          formData.append("gapColor", this.form.gapColor);
          formData.append("width", this.form.width);
          formData.append("materialType", this.form.materialType);
          formData.append("shpName", this.form.fileName);
          formData.append("dashLength", this.form.dashLength);
          axios
            .post("/baseIP/ShpInfo/upload", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization:
                  "Bearer " + window.sessionStorage.getItem("token"),
                "X-Authorization":
                  "Bearer " + window.sessionStorage.getItem("refreshToken"),
              },
            })
            .then((res) => {
              if (res.data.code == 200 || res.data.code == 204) {
                shpInfoListMap.init();
                this.closeVector();
                this.$emit("addKmlOrShpSuccess");
                this.$notify({
                  title: "保存成功",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              }
            });
        }
      } else {
        // 编辑
        // KML
        if (this.isKmlOrShpWithUpload == 1) {
          this.form.textDistinct = this.form.visibleRange;
          editKmlInfo(this.form).then((res) => {
            let { code } = res.data;
            if (code == 200 || code == 204) {
              kmlMap.removeLayer();
              this.closeVector();
              this.$emit("addKmlOrShpSuccess");
              this.$notify({
                title: "编辑成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            } else {
              this.$notify({
                title: "编辑失败",
                message: "",
                type: "error",
                duration: 960,
                offset: 320,
              });
            }
          });
        }
        // SHP
        if (this.isKmlOrShpWithUpload == 2) {
          this.form.shpDistinct = this.form.visibleRange;
          this.form.gapColor =
            this.form.gapColor == null ? "" : this.form.gapColor;
          editShpInfo(this.form).then((res) => {
            // const model = this.$GLOBAL.map.getLayer(this.form.id, "modelId");
            // if (model) {
            //   shpInfoListMap.showChinaLineId(false, this.form.id);
            // }
            let { code } = res.data;
            if (code == 200 || code == 204) {
              shpInfoListMap.init();
              this.closeVector();
              this.$emit("addKmlOrShpSuccess");
              this.$notify({
                title: "编辑成功",
                message: "",
                type: "success",
                duration: 960,
                offset: 320,
              });
            } else {
              this.$notify({
                title: "编辑失败",
                message: "",
                type: "error",
                duration: 960,
                offset: 320,
              });
            }
          });
        }
      }
    },
    // 三级菜单编辑
    threeEdit() {
      const value = this.isSecondaryAdd.obj.value;
      // SHP编辑回显
      if (value === "ShpInfo") {
        const { shpDistinct } = this.isSecondaryAdd.obj.shpInfo;
        Object.assign(this.form, this.isSecondaryAdd.obj.shpInfo);
        this.form.visibleRange = shpDistinct;
      }
      if (value === "KmlInfo") {
        const { textDistinct } = this.isSecondaryAdd.obj.kmlInfo;
        Object.assign(this.form, this.isSecondaryAdd.obj.kmlInfo);
        this.form.visibleRange = textDistinct;
      }
    },
    // 二级菜单新增时赋值分组数据
    secondAdd() {
      this.resetData();
      if (!this.isSecondaryAdd.isShow) {
        this.form.selectGrouping = this.isSecondaryAdd.obj;
        if (this.isSecondaryAdd.obj.value === "KmlInfo") {
          this.uploadAccept = ".kml";
          this.isKmlOrShpWithUpload = 1;
          this.form.actionUrl = "/baseIP/KmlInfo/upload";
        }
        if (this.isSecondaryAdd.obj.value === "ShpInfo") {
          this.uploadAccept = ".json";
          this.isKmlOrShpWithUpload = 2;
          this.form.actionUrl = "/baseIP/ShpInfo/upload";
        }
      }
    },
    // 文件改变时
    uploadChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      let name = fileList[0].name;
      const index = name.lastIndexOf(".");
      const res = name.substring(index + 1, name.length);
      if (
        (this.isKmlOrShpWithUpload == 1 && res == "kml") ||
        (this.isKmlOrShpWithUpload == 2 && res == "json")
      ) {
        this.form.fileName = name.substring(0, index);
        this.fileList = fileList;
      } else {
        this.form.fileName = null;
        this.fileList = [];
        this.$notify({
          title: "请上传对应类型文件",
          message: "",
          type: "error",
          duration: 960,
          offset: 320,
        });
      }
    },
    // 选择分组切换
    selectGroupingChange(data) {
      if (data)
        Object.keys(data).find((item) => {
          if (item === "kmlInfo") {
            console.log("是KML上传");
            this.uploadAccept = ".kml";
            this.isKmlOrShpWithUpload = 1;
            this.form.actionUrl = "/baseIP/KmlInfo/upload";
          }
          if (item === "shpInfo") {
            console.log("是SHP上传");
            this.uploadAccept = ".json";
            this.isKmlOrShpWithUpload = 2;
            this.form.actionUrl = "/baseIP/ShpInfo/upload";
          }
        });
    },
    // 获取KML和SHP数据
    async getKmlAndShp() {
      const kmlList = await KmlInfoFkKmlInfoList(
        sessionStorage.getItem("nowProjectId")
      );
      const ShpList = await ShpInfoFkSmlInfoList(
        sessionStorage.getItem("nowProjectId")
      );
      // 赋值下拉框数据
      this.selectGroupingList = kmlList.data.data.concat(ShpList.data.data);
      // 赋值默认选中第一个
      this.form.selectGrouping = this.selectGroupingList[0];
      // 第一个是KML还是SHP判断隐藏显示对应面板
      this.selectGroupingChange(this.form.selectGrouping);
    },
    // 获取SHP下拉框材质
    getMaterial() {
      sysDictTypeDropDown("material_Type").then((res) => {
        this.lineMaterialOptions = res.data.data;
      });
    },
  },
  mounted() {
    this.getKmlAndShp();
    this.getMaterial();
  },
};
